module.exports = __webpack_public_path__ + "static/media/logo-black.2b944747.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/logo-black.png
// module id = 373
// module chunks = 11